var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", _vm._l(_vm.tabList, function (tabItem, k) {
    return _c("div", {
      key: k
    }, [_vm.activeTab === tabItem.key ? _vm._l(tabItem.list, function (item, index) {
      return _c("ul", {
        key: index,
        staticClass: "group"
      }, [_c("li", {
        class: ["group-name", {
          active: tabItem.activeGroupCode.indexOf(item.group_code) !== -1
        }],
        on: {
          click: function ($event) {
            return _vm.$emit("changeCollapsed", {
              group_code: item.group_code
            });
          }
        }
      }, [_c("span", {
        attrs: {
          title: item.group_name
        }
      }, [_vm._v(_vm._s(item.group_name.length > 10 ? item.group_name.slice(0, 10) + "..." : item.group_name))]), _c("img", {
        class: {
          up: tabItem.activeGroupCode.indexOf(item.group_code) !== -1
        },
        attrs: {
          src: tabItem.activeGroupCode.indexOf(item.group_code) !== -1 ? _vm.ypng : _vm.npng,
          alt: "箭头"
        }
      })]), _c("li", {
        staticClass: "group-list"
      }, [_c("transition", {
        attrs: {
          name: "collapse-transition"
        },
        on: {
          "before-enter": _vm.collapseBeforeEnter,
          enter: _vm.collapseEnter,
          "after-enter": _vm.collapseAfterEnter,
          "before-leave": _vm.collapseBeforeLeave,
          leave: _vm.collapseLeave,
          "after-leave": _vm.collapseAfterLeave
        }
      }, [tabItem.activeGroupCode.indexOf(item.group_code) !== -1 ? _c("ol", _vm._l(item.list, function (val, key) {
        return _c("li", {
          key: key,
          class: {
            active: val._id === tabItem.activeId
          },
          on: {
            click: function ($event) {
              return _vm.$emit("changeDetail", {
                activeId: val._id,
                group_code: item.group_code
              });
            }
          }
        }, [_vm._v(_vm._s(tabItem.key === "component" ? val.component_name : val.interface_name))]);
      }), 0) : _vm._e()])], 1)]);
    }) : _vm._e()], 2);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };